//frontend/src/pages/AziendePage.jsx
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import TornaAlMenu from "../components/TornaAlMenu";

const API_URL = process.env.REACT_APP_API_URL || "";

const initialForm = {
  name: "",
  vat: "",
  email: "",
  phone: "",
  address: "",
  ref_contact: "",
  notes: "",
  unique_code: "",
};

export default function AziendePage() {
  const [aziende, setAziende] = useState([]);
  const [caricamento, setCaricamento] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState(initialForm);
  const [q, setQ] = useState("");
  const [ordinamento, setOrdinamento] = useState("name-asc");
  const [hasFullPackage, setHasFullPackage] = useState(null); // null=non caricato
  const nav = useNavigate();
  const [referenti, setReferenti] = useState([]);
  const [referente, setReferente] = useState("");


useEffect(() => {
  const token = localStorage.getItem("access");
  if (!token) return;

  (async () => {
    try {
      const r = await fetch(`${API_URL}/api/me/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const me = await r.json();
      const full = !!me?.has_full_package;
      setHasFullPackage(full);

      if (full) {
        fetchAziende();
      } else {
        // FREE: non carichiamo aziende
        setAziende([]);
        setCaricamento(false);
      }
    } catch (e) {
      setHasFullPackage(false);
      setAziende([]);
      setCaricamento(false);
    }
  })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  const fetchAziende = async () => {
    setCaricamento(true);
    try {
      const res = await fetch(`${API_URL}/api/aziende/`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("access")}` },
      });
      const data = await res.json();
      setAziende(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error(e);
    }
    setCaricamento(false);
  };

  const fetchReferenti = async () => {
    try {
      const res = await fetch(`${API_URL}/api/referenti/`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("access")}` },
      });
      const data = await res.json();
      setReferenti(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error(e);
      setReferenti([]);
    }
  };
  
const resetForm = () => setFormData(initialForm);

  const submitAzienda = async (e) => {
    e.preventDefault();
    if (!referente) {
      alert("❌ Seleziona obbligatoriamente un referente.");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/api/aziende/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...formData, referente }),
      });
      if (!res.ok) throw new Error(await res.text());
      alert("✅ Azienda creata!");
      setShowForm(false);
      resetForm();
      fetchAziende();
    } catch (err) {
      alert("❌ Errore: " + err.message);
    }
  };

  // Filtro + ordinamento in memoria (veloci e gradevoli)
  const aziendeFiltrate = useMemo(() => {
    let out = [...aziende];
    const k = q.trim().toLowerCase();
    if (k) {
      out = out.filter((a) =>
        [a.name, a.code, a.email, a.phone].some((v) =>
          String(v || "").toLowerCase().includes(k)
        )
      );
    }
    if (ordinamento === "name-asc") out.sort((a, b) => a.name.localeCompare(b.name));
    if (ordinamento === "name-desc") out.sort((a, b) => b.name.localeCompare(a.name));
    if (ordinamento === "code-asc") out.sort((a, b) => String(a.code).localeCompare(String(b.code)));
    if (ordinamento === "code-desc") out.sort((a, b) => String(b.code).localeCompare(String(a.code)));
    return out;
  }, [aziende, q, ordinamento]);

  return (
    <div className="container mt-4">
      <TornaAlMenu to="/" />

      {/* Header pagina */}
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
        <h2 className="m-0">🏢 Aziende</h2>
        <div className="d-flex gap-2">
          {!showForm ? (
<button
  className="btn btn-success"
  onClick={() => {
    if (hasFullPackage === false) {
      alert("🔒 Funzione disponibile solo nel pacchetto FULL.");
      return;
    }
    resetForm();
    setReferente("");
    fetchReferenti();
    setShowForm(true);
  }}
  title="Inserisci una nuova azienda"
>
  + Aggiungi Azienda
</button>

          ) : (
            <button
              className="btn btn-outline-secondary"
              onClick={() => {
                setShowForm(false);
                resetForm();
              }}
            >
              ← Annulla
            </button>
          )}
          <button className="btn btn-outline-primary" onClick={fetchAziende}>
            🔄 Aggiorna
          </button>
        </div>
      </div>

      {/* Barra strumenti elenco */}
      {!showForm && (
        <div className="card shadow-sm mb-3">
          <div className="card-body">
            <div className="row g-2 align-items-end">
              <div className="col-md-6">
                <label className="form-label mb-1">Cerca</label>
                <input
                  className="form-control"
                  placeholder="🔎 Nome, codice, email o telefono…"
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                />
              </div>

              <div className="col-md-3">
                <label className="form-label mb-1">Ordina per</label>
                <select
                  className="form-select"
                  value={ordinamento}
                  onChange={(e) => setOrdinamento(e.target.value)}
                >
                  <option value="name-asc">Nome (A → Z)</option>
                  <option value="name-desc">Nome (Z → A)</option>
                  <option value="code-asc">Codice (A → Z)</option>
                  <option value="code-desc">Codice (Z → A)</option>
                </select>
              </div>
              <div className="col-md-3 text-md-end">
                <button className="btn btn-outline-secondary mt-3 mt-md-0" onClick={() => setQ("")}>
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* FORM elegante, responsive, 2 colonne su md+ */}
      {showForm && (
        <div className="card shadow-sm border-0 mb-4">
          <div className="card-header bg-white">
            <h5 className="m-0">📝 Nuova Azienda</h5>
            <small className="text-muted">
              Compila i campi essenziali; potrai sempre modificarli in seguito.
            </small>
          </div>

          <form className="card-body" onSubmit={submitAzienda}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">
                  Nome Azienda <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  value={formData.name}
                  onChange={(e) => setFormData((f) => ({ ...f, name: e.target.value }))}
                  placeholder="Es. Rossi S.r.l."
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">
                  P.IVA / Codice Fiscale <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  value={formData.vat}
                  onChange={(e) => setFormData((f) => ({ ...f, vat: e.target.value }))}
                  placeholder="Es. 01234567890"
                  required
                />
              </div>
<div className="col-md-6">
  <label className="form-label">
    Referente / Distributore <span className="text-danger">*</span>
  </label>
  <select
    className="form-select"
    value={referente}
    onChange={(e) => setReferente(e.target.value)}
    required
  >
    <option value="">— Seleziona —</option>
    {referenti.map((r) => (
      <option key={r.value} value={r.value}>
        {r.label}
      </option>
    ))}
  </select>
</div>

              <div className="col-md-4">
                <label className="form-label">Codice Univoco SDI</label>
                <input
                  className="form-control"
                  value={formData.unique_code}
                  onChange={(e) => setFormData((f) => ({ ...f, unique_code: e.target.value }))}
                  placeholder="Es. ABCDEF1"
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={formData.email}
                  onChange={(e) => setFormData((f) => ({ ...f, email: e.target.value }))}
                  placeholder="azienda@email.it"
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Telefono</label>
                <input
                  className="form-control"
                  value={formData.phone}
                  onChange={(e) => setFormData((f) => ({ ...f, phone: e.target.value }))}
                  placeholder="Es. 349 000 0000"
                />
              </div>

              <div className="col-12">
                <label className="form-label">Indirizzo</label>
                <input
                  className="form-control"
                  value={formData.address}
                  onChange={(e) => setFormData((f) => ({ ...f, address: e.target.value }))}
                  placeholder="Via Roma 10, Milano (MI)"
                />
              </div>

                <div className="col-md-4">
                  <label className="form-label">CAP</label>
                  <input
                    className="form-control"
                    value={formData.cap || ""}
                    onChange={(e) => setFormData((f) => ({ ...f, cap: e.target.value }))}
                    placeholder="20100"
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Città</label>
                  <input
                    className="form-control"
                    value={formData.citta || ""}
                    onChange={(e) => setFormData((f) => ({ ...f, citta: e.target.value }))}
                    placeholder="Milano"
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Provincia</label>
                  <input
                    className="form-control"
                    value={formData.provincia || ""}
                    onChange={(e) => setFormData((f) => ({ ...f, provincia: e.target.value }))}
                    placeholder="MI"
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Nazione</label>
                  <input
                    className="form-control"
                    value={formData.nazione || ""}
                    onChange={(e) => setFormData((f) => ({ ...f, nazione: e.target.value }))}
                    placeholder="IT"
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">PEC</label>
                  <input
                    className="form-control"
                    value={formData.pec || ""}
                    onChange={(e) => setFormData((f) => ({ ...f, pec: e.target.value }))}
                    placeholder="pec@azienda.it"
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Codice Fiscale</label>
                  <input
                    className="form-control"
                    value={formData.cf || ""}
                    onChange={(e) => setFormData((f) => ({ ...f, cf: e.target.value }))}
                    placeholder="Codice fiscale"
                  />
                </div>

              <div className="col-md-6">
                <label className="form-label">Contatto referente</label>
                <input
                  className="form-control"
                  value={formData.ref_contact}
                  onChange={(e) => setFormData((f) => ({ ...f, ref_contact: e.target.value }))}
                  placeholder="Es. Marco Rossi"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Note</label>
                <textarea
                  className="form-control"
                  rows={1}
                  value={formData.notes}
                  onChange={(e) => setFormData((f) => ({ ...f, notes: e.target.value }))}
                  placeholder="Annotazioni utili"
                />
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2 mt-4">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => {
                  setShowForm(false);
                  resetForm();
                }}
              >
                Annulla
              </button>
              <button className="btn btn-primary" type="submit">
                Salva Azienda
              </button>
            </div>
          </form>
        </div>
      )}

      {/* LISTA aziende: griglia elegante di card responsive */}
      {!showForm && (
        <>
          {caricamento ? (
            <div className="text-muted">⏳ Caricamento…</div>
          ) : aziendeFiltrate.length === 0 ? (
            <div className="alert alert-info">
              Nessuna azienda trovata. Prova a cambiare i filtri oppure
              aggiungine una nuova.
            </div>
          ) : (
            <div className="row g-3">
              {aziendeFiltrate.map((a) => (
                <div className="col-12 col-md-6 col-lg-4" key={a.code}>
                  <div
                    className="card h-100 shadow-sm border-0 hover-shadow"
                    role="button"
                    onClick={() => nav(`/aziende/${a.code}`)}
                    style={{ transition: "transform .08s ease-in-out" }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-2px)")}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
                  >
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-start">
                        <h5 className="card-title mb-1">{a.name}</h5>
                        <span className="badge bg-light text-dark">Cod. {a.code}</span>
                      </div>
                      {a.address && (
                        <p className="text-muted small mb-2">{a.address}</p>
                      )}

                      <div className="small">
                        {a.phone && (
                          <p className="mb-1">
                            <span className="text-muted">Telefono:</span> {a.phone}
                          </p>
                        )}
                        {a.email && (
                          <p className="mb-0">
                            <span className="text-muted">Email:</span> {a.email}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="card-footer bg-white border-0 pt-0">
                      <button className="btn btn-sm btn-outline-primary">
                        Apri scheda →
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
